import { useState } from 'react';

import CommandPalette, {
  filterItems,
  getItemIndex,
  useHandleOpenCommandPalette,
} from 'react-cmdk';
import 'react-cmdk/dist/cmdk.css';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { PreferencesActions } from '@/app/slices/preferences';

export const CommandK = () => {
  const dispatch = useDispatch();

  const [page, setPage] = useState<'root' | 'apps'>('root');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [search, setSearch] = useState('');

  const navigate = useNavigate();
  useHandleOpenCommandPalette(setIsOpen);

  const filteredItems = filterItems(
    [
      {
        heading: 'Home',
        id: 'home',
        items: [
          {
            id: 'home',
            children: 'Home',
            icon: 'HomeIcon',
            onClick: () => {
              navigate('/');
            },
          },
        ],
      },
      {
        heading: 'Apps',
        id: 'advanced',
        items: [
          {
            id: 'chute-scheduler',
            children: 'Chute Scheduler',
            icon: 'WindowIcon',
            onClick: () => {
              navigate('/chute-scheduler');
            },
          },
          {
            id: 'stripping',
            children: 'Stripping',
            icon: 'WindowIcon',
            onClick: () => {
              navigate('/stripping');
            },
          },
          {
            id: 'shipping',
            children: 'Shipping',
            icon: 'WindowIcon',
            onClick: () => {
              navigate('/shipping/all-shipments');
            },
          },
          {
            id: 'apps',
            children: 'Apps',
            icon: 'RectangleStackIcon',
            closeOnSelect: false,
            onClick: () => {
              setPage('apps');
            },
          },
        ],
      },
      {
        heading: 'Other',
        id: 'advanced',
        items: [
          {
            id: 'settings',
            children: 'Settings',
            icon: 'CogIcon',
            onClick: () => {
              dispatch({ type: PreferencesActions.UPDATE_SHOW, show: true });
            },
          },
          {
            id: 'log-out',
            children: 'Log out',
            icon: 'ArrowRightOnRectangleIcon',
            onClick: () => {
              navigate('/logout');
            },
          },
        ],
      },
    ],
    search,
  );

  return (
    <CommandPalette
      onChangeSearch={setSearch}
      onChangeOpen={setIsOpen}
      search={search}
      isOpen={isOpen}
      page={page}
    >
      <CommandPalette.Page id="root">
        {filteredItems.length ? (
          filteredItems.map((list) => (
            <CommandPalette.List key={list.id} heading={list.heading}>
              {list.items.map(({ id, ...rest }) => (
                <CommandPalette.ListItem
                  key={id}
                  index={getItemIndex(filteredItems, id)}
                  {...rest}
                />
              ))}
            </CommandPalette.List>
          ))
        ) : (
          <CommandPalette.FreeSearchAction />
        )}
      </CommandPalette.Page>

      <CommandPalette.Page id="apps">
        {/* App page */}
        <div>App content goes here</div>
      </CommandPalette.Page>
    </CommandPalette>
  );
};
